import { render, staticRenderFns } from "./MetasConsultoria.vue?vue&type=template&id=739e80d0"
import script from "./MetasConsultoria.vue?vue&type=script&lang=js"
export * from "./MetasConsultoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports